module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS12.aa4e7f35.jpg";